import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from "@madmedical/i18n";
import { usePregnancyData } from "../../providers";
import Breadcrumb from "../../molecules/Breadcrumb";
import Headline from "../../molecules/Headline";
const PregnancyDoctorEditBreadcrumbs = () => {
    const { patient } = usePregnancyData();
    const { t } = useTranslation();
    return (_jsx(Headline, { minHeight: 12, borderBottomWidth: 1, borderBottomColor: "gray.100", borderBottomStyle: "solid", mb: 4, leftContent: _jsxs(Breadcrumb, { children: [_jsx(Breadcrumb.Item, { children: _jsx(Breadcrumb.Link, Object.assign({ route: "dashboard", params: {} }, { children: t("health") })) }), _jsx(Breadcrumb.Item, { children: _jsx(Breadcrumb.Link, Object.assign({ route: "patient", params: { patientId: patient.userId } }, { children: patient.fullName })) }), _jsx(Breadcrumb.Item, { children: _jsx(Breadcrumb.Text, { children: t("pregnancy:editPregnancy") }) })] }) }));
};
export default PregnancyDoctorEditBreadcrumbs;
